import { ModalAllder } from 'layouts/ModalAllder';
import { useEffect } from 'react';

export default function SuccessModal({ modal, setModal, successType = 'delete', ...props }) {
  useEffect(() => {
    if (modal?.open || modal) {
      const timer = setTimeout(() => {
        if (typeof setModal === 'function') {
          if (modal?.open !== undefined) {
            setModal(prev => ({ ...prev, open: false }));
          } else {
            setModal(false);
          }
        }
      }, 1500);

      return () => clearTimeout(timer);
    }
  }, [modal, setModal]);

  const getMessage = () => {
    switch (successType) {
      case 'create':
        return 'เพิ่ม Tag ส่วนลด สำเร็จ';
      case 'edit':
        return 'แก้ไข Tag ส่วนลด สำเร็จ';
      case 'delete':
      default:
        return 'ลบ Tag ส่วนลด สำเร็จ';
    }
  };

  const isModalOpen = modal?.open !== undefined ? modal.open : modal;

  return (
    <ModalAllder modal={modal} setModal={setModal} htitle={''} hbtn={false}>
      <div className="py-4">
        <div className="text-center mb-4">
          <svg
            className="mx-auto"
            width="84"
            height="83"
            viewBox="0 0 84 83"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="42" cy="41.5" r="41.5" fill="#2DC76D" />
            <path
              d="M56.0123 30.9902L36.7444 50.2581L27.9863 41.5"
              stroke="white"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <div className="text-center fs-22 tc-7">{getMessage()}</div>
      </div>
    </ModalAllder>
  );
}
